import React from "react";
import logo from "../Assets/imgs/logo.webp"
import facebook from "../Assets/imgs/facebook.webp";
import insta from "../Assets/imgs/instagram.webp";
import whatsap from "../Assets/imgs/whatsapp.webp";
import linkedin from "../Assets/imgs/linkedin.webp"

const Footer = () => {
  return (
    <>
      <div className="__footerSection">
        <div className="container-fluid">
          <div className="__line"></div>
          <div className="row">
            <div className="col-lg-6">
              <div className="__footLogo">
                <img src={logo} alt="logo" />
              </div>
              <div className="__getInTocuh">Get In Touch</div>
              <div className="__footerflex">
                <div className="__footArrowParent">
                  <div className="__footArrow">
                    <i className="ri-corner-down-right-fill"></i>
                  </div>
                  <div className="__absfootArrow">
                    <i className="ri-corner-down-right-fill"></i>
                  </div>
                </div>
                <div className="__compneyName">dbx360.com</div>
              </div>
              <div className="__socialLinks">
                <a href="#">
                  <img src={facebook} alt="facebook" />
                </a>
                <a href="#">
                  <img src={whatsap} alt="whatsap" />
                </a>
                <a href="#">
                  <img src={insta} alt="insta" />
                </a>
                <a href="#">
                  <img src={linkedin} alt="insta" />
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="__getInTocuh">Let's Strategize</div>
              <div className="__schedule">
                Schedule a<br /> strategy session
              </div>
              <button className="__sessionBtn">
                <div className="__sessionLeftDiv">
                  <i className="ri-arrow-right-line"></i>
                </div>
                <div className="__SessionRightSide">
                  <p>Book a session</p>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </button>
              <div className="__line"></div>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                  <div className="__footLinks">
                    <p>Navigation</p>
                    <ul>
                      <li>
                        <a href="#">Services</a>
                      </li>
                      <li>
                        <a href="#">Solutions</a>
                      </li>
                      <li>
                        <a href="#">Success Stories</a>
                      </li>
                      <li>
                        <a href="#">Blog</a>
                      </li>
                      <li>
                        <a href="#">Team</a>
                      </li>
                      <li>
                        <a href="#">Careers</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <div className="__footLinks">
                    <p>social</p>
                    <ul>
                      <li>
                        <a href="#">Linkedin</a>
                      </li>
                    </ul>
                  </div>
                  <div className="__footLinks mt__top">
                    <p>newsletter</p>
                    <div className="email__Input">
                      <input type="text" placeholder="Your Email" />
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="__FootBottom">
            <div className="__CoyyRightSection">
              <p>Copyright © DBX360 2025 / All Rights Reserved</p>
              <div className="__links">
                <a href="#">Terms & Conditions</a>
                <span>and</span>
                <a href="#">Privacy Policy</a>
              </div>
            </div>
            <div className="__websiteBY">Website By DBX360</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
